import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
  useRef
} from 'react';
import LeadService from '../../services/leadService';
import { useParams, useHistory } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { toast } from 'react-toastify';
import { FiEdit } from 'react-icons/fi';
import {
  Row,
  Form,
  Card,
  CardBody,
  CardHeader,
  Col,
  Input,
  Container,
  Button,
  ButtonGroup
} from 'reactstrap';
import ConversationDetails from 'components/Conversation/ConversationDetails';

import SimpleHeader from 'components/Headers/SimpleHeader.js';
import LeadStageService from '../../../LeadStages/service';
import Loader from 'components/Loader';
import ReactButton from 'components/Buttons/ReactButton';
import CustomFieldsInputsForm from '../../../shared/components/CustomFieldsInputsForm';
import { useEntityCustomFieldsByRecordType } from 'views/fieldConfigs/hooks/useCustomFieldsByRecordType';
import {
  maskPhoneNumber,
  removeMaskSpecialCharacters
} from 'views/CRM/shared/utils/phoneNumberHelpers';
import { entitiesName } from 'views/CRM/shared/utils/entitiesName';
import { toBrazilianFullDate } from 'views/CRM/shared/utils/date';
import ConvertLeadModal from './ConvertLeadModal';
import './styles.css';
import ChangeResponsibleModal from './ChangeResponsibleModal';
import ListComments from './Comments/CommentsList';
import CommentModal from './Comments/CommentsForm';
import ModalComment from './Comments/ModalUpdateComment';
import { FiPlus } from 'react-icons/fi';
import { formatCustomFieldsToSubmit } from 'views/CRM/shared/helpers/customFieldsHelpers';
import { formatCustomFieldsToDisplay } from 'views/CRM/shared/helpers/customFieldsHelpers';
import { Attachments } from '../../../shared/components/UploadAttachments';
import TemplatesModal from 'views/ServicePanel/components/QueueContent/components/Contact/TemplatesModal';
import ContactAttemptTimelineModal from '../../../shared/ContactAttempt/components/ContactTimeLineModal';
import { getContactsAttempts } from '../../../shared/ContactAttempt/utils';
import LeadTimeModal from './LeadTime';
import styled from 'styled-components';
import { FiChevronDown, FiChevronRight } from 'react-icons/fi';
import { useGetLostReasonByEntity } from '../../../hooks/useGetLostReasonByEntity';
import ModalLostReason from './ModalLostReason/index';
import ListSchedules from '../../../Scheduling/SchedulesList/index';
import ModalSchedulingProtocol from '../../../Scheduling/ModalScheduling/index';
import SchedulingCrmService from '../../services/scheduleCrmService';
import { FlexController } from 'components/FlexControllerInput';
import { getDefaultCountry } from 'services/ServiceCOUNTRYS';
import CatalogProductsForm from '../../../PriceCatalog/externalForm/CatalogProductsForm';
import RecordTypeService from '../../../../RecordType/service';
import ShowHistoryChanges from 'components/HistoryChanges';
import { normalizePhoneNumber } from 'utils/fuctions/internationalPhoneFormatter';
import { normalizeDDI } from 'utils/fuctions/internationalPhoneFormatter';
import SendEmailModal from '../../list/components/SendEmailModal';

const CustomFieldsFilterToggle = styled.div`
  display: inline-block;
  margin-bottom: 1rem;
  user-select: none;
  :hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;
const LeadEdit = (
  showMessageIconOnPhoneField = false,
  showCallIconOnPhoneField = false
) => {
  const { control, reset, setValue, handleSubmit, errors, watch, getValues } =
    useForm();
  const { recordTypeId, id } = useParams();
  const history = useHistory();

  const catalogFormRef = useRef(null);

  const { getCustomFields, customFields, isLoadingCustomFields } =
    useEntityCustomFieldsByRecordType(entitiesName.LEAD, recordTypeId);

  const [lead, setLead] = useState();
  const leadStageId = lead?.stageId;
  const [activeStage, setActiveStage] = useState();
  const [leadStages, setLeadStages] = useState();
  const [availableStages, setAvailableStages] = useState([]);
  const [openModalReason, setOpenModalReason] = useState(false);
  const [updateLostReason, setUpdateLostReason] = useState({});
  const [leadCatalog, setLeadCatalog] = useState(null);
  const [isModalEmailLeadOpen, setIsModalEmailLeadOpen] = useState(false);
  const [leadEmail, setLeadEmail] = useState(null);

  const currentLeadStage = useMemo(() => {
    if (!leadStageId || !leadStages) return undefined;

    const leadStage = leadStages.find((item) => item.id === leadStageId);

    return leadStage;
  }, [leadStageId, leadStages]);

  const filteredCustomFields = useMemo(() => {
    if (!currentLeadStage) return customFields;
    const filtered = customFields.filter((field) =>
      currentLeadStage?.fieldsDisplay?.includes(field.id)
    );

    filtered.forEach((element) => {
      if (currentLeadStage?.fieldsBlocked?.includes(element.id)) {
        element.blocked = true;
      }

      if (currentLeadStage?.fieldsRequired?.includes(element.id)) {
        element.required = true;
      }
    });

    return filtered;
  }, [customFields, currentLeadStage]);

  const [changedStage, setChangedStage] = useState(false);
  const [isSubmiting, setIsSubmiting] = useState(false);
  const [isConvertLeadModalOpen, setIsConvertLeadModalOpen] = useState(false);
  const [isChangeReponsibleModalOpen, setIsChangeReponsibleModalOpen] =
    useState(false);
  const [
    isContactAttemptTimelineModalOpen,
    setIsContactAttemptTimelineModalOpen
  ] = useState(false);
  const [listComments, setListComments] = useState([]);
  const [openModalUpdateComment, setOpenModalUpdateComment] = useState(false);
  const [openModalCreateComment, setOpenModalCreateComment] = useState(false);
  const [openModalLeadTime, setOpenModalLeadTime] = useState(false);
  const [isEditLostReason, setIsEditLostReason] = useState(false);
  const [openModalLostReason, setOpenModalLostReason] = useState(false);

  const [dataCommentUpdate, setDataCommentUpdate] = useState([]);
  const [isConvertStateId, setIsConvertStateId] = useState({});
  const [isModalTemplateMessageLeadOpen, setIsisModalTemplateMessageLeadOpen] =
    useState(false);
  const [whatsAppMessageContactInfoLead, setWhatsAppMessageContactInfoLead] =
    useState({});

  const [chatCreatedOnIsolatedMessageId, setChatCreatedOnIsolatedMessageId] =
    useState(null);

  const [callUniqueId, setCallUniqueId] = useState(null);

  const { listLostReason } = useGetLostReasonByEntity({
    entity: entitiesName.LEAD,
    recordTypeId
  });

  const [listSchedules, setListSchedules] = useState([]);
  const [isCurrentResponsible, setIsCurrentResponsible] = useState('');
  const [isSchedulingModalOpen, setIsSchedulingModalOpen] = useState(false);
  const [isToUpdateScheduling, setIsToUpdateScheduling] = useState(false);
  const [isToCreateScheduling, setIsToCreateScheduling] = useState(false);
  const [schedulingId, setschedulingId] = useState();
  const [recordType, setRecordType] = useState(null);
  const [leadCatalogChangeHistory, setLeadCatalogChangeHistory] = useState([]);
  const [leadConversations, setLeadConversations] = useState([]);

  useEffect(() => {
    if (recordTypeId) {
      RecordTypeService.get(recordTypeId)
        .then((res) => {
          const recordTypeData = res.data.content.disable_link_to_product;
          setRecordType(recordTypeData);
        })
        .catch((error) => {
          const errorMsg = error.response?.data?.message;
          toast.error(errorMsg || 'Erro ao buscar tipo de registro');
        });
    }
  }, [recordTypeId]);

  const getLeadCatalogChangesHistory = useCallback(() => {
    const leadCatalogId = lead?.catalog?.id;
    LeadService.getLeadCatalogHistoryChanges(leadCatalogId)
      .then((response) => {
        setLeadCatalogChangeHistory(response.data.data);
      })
      .catch(() => {
        toast.error(
          'Ocorreu um erro ao buscar o histórico de alterações do catálogo do lead'
        );
      });
  }, [lead]);

  const getLeadConversations = useCallback(() => {
    if (!id) return;

    LeadService.getConversationsByLead(id)
      .then((res) => {
        setLeadConversations(res.data.conversas || res.data.data || []);
      })
      .catch((err) => {
        // Não exibe erro se não houver conversas associadas
        if (err?.response?.status !== 404) {
          console.error('Erro ao buscar conversas do lead:', err);
        }
      });
  }, [id]);

  useEffect(() => {
    if (!lead?.catalog) return;
    getLeadCatalogChangesHistory();
  }, [getLeadCatalogChangesHistory]);

  useEffect(() => {
    getLeadConversations();
  }, [getLeadConversations]);

  useEffect(() => {
    if (chatCreatedOnIsolatedMessageId) {
      getContactsAttempts(chatCreatedOnIsolatedMessageId, 'CHAT', 'LEAD', id);
      return;
    }

    if (callUniqueId) {
      getContactsAttempts(callUniqueId, 'TELEFONIA', 'LEAD', id);
      return;
    }
  }, [callUniqueId, chatCreatedOnIsolatedMessageId, id]);

  useEffect(() => {
    getCustomFields();
  }, [getCustomFields]);

  useEffect(() => {
    if (!isLoadingCustomFields) {
      getLeadById();
    }
  }, [isLoadingCustomFields, getLeadById]);

  const getLeadById = useCallback(async () => {
    LeadService.getById(recordTypeId, id)
      .then(({ data }) => {
        const leadData = {
          ...data.data,
          phone: maskPhoneNumber(data.data.phone)
        };
        const formattedLead = formatCustomFieldsToDisplay(
          leadData,
          customFields
        );

        const ddi = formattedLead?.ddi?.startsWith?.('+')
          ? formattedLead?.ddi?.replace?.('+', '')
          : formattedLead?.ddi;

        const resetValues = {
          ...formattedLead,
          phone: {
            ddi,
            number: formattedLead?.phone
          }
        };

        setAvailableStages(data.data.stagesFree);
        setLead(formattedLead);
        setLeadCatalog(formattedLead.catalog);
        setListSchedules(data.data.schedulingCrm);
        setIsCurrentResponsible(localStorage.getItem('login'));
        reset(resetValues);
        setActiveStage(leadData.stageId);
        if (catalogFormRef.current) {
          catalogFormRef.current.forceUpdate();
        }
      })
      .catch((err) => {
        toast.error(
          err.response?.data?.message || 'Erro ao buscar dados do Lead'
        );
      });
  }, [id, recordTypeId, customFields, reset]);

  const getCommnents = useCallback(() => {
    if (id) {
      LeadService.getLeadComments(id)
        .then((res) => {
          setListComments(res.data.data);
        })
        .catch(() => {
          toast.error('Houve um erro ao buscar os comentários desse lead', {
            closeOnClick: true,
            autoClose: 3000
          });
        });
    }
  }, [id]);

  useEffect(getCommnents, [getCommnents]);

  const changeStage = (stage) => {
    setActiveStage(stage);
  };

  const convertLead = async (data) => {
    setIsConvertStateId(data);
    validationFieldRequired();
  };

  const openContactAttemptTimeline = async () => {
    setIsContactAttemptTimelineModalOpen(true);
  };

  const changeResponsible = async () => {
    setIsChangeReponsibleModalOpen(true);
  };

  const validationFieldRequired = async () => {
    const data = {
      recordTypeId: recordTypeId,
      stageId: isConvertStateId.stageId || activeStage
    };
    await LeadService.validateFieldRequired(lead.id, data)
      .then(() => {
        setIsConvertLeadModalOpen(true);
      })
      .catch((error) => {
        const errMsg =
          error.response?.data?.message || 'Erro ao atualizar a fase.';
        toast.error(errMsg, {
          autoClose: 3000,
          closeOnClick: true
        });
      })
      .finally(() => {
        setIsSubmiting(false);
      });
  };

  const changeLeadStage = async (data) => {
    if (lead.isConverted) {
      toast.error('Não é possível alterar a fase de um lead convertido.', {
        closeOnClick: true,
        autoClose: 3000
      });
      return;
    }
    LeadService.updateStage(lead.id, data)
      .then(() => {
        setLead({ ...lead, stageId: data.stageId });
        setChangedStage(true);
        setActiveStage(data.stageId);
        toast.success('Fase atualizada com sucesso.', {
          closeOnClick: true,
          autoClose: 3000
        });
      })
      .catch((error) => {
        const errMsg =
          error.response?.data?.message || 'Erro ao atualizar a fase.';
        toast.error(errMsg, {
          autoClose: 3000,
          closeOnClick: true
        });
      })
      .finally(() => {
        setIsSubmiting(false);
      });
  };

  const updateStage = async () => {
    if (isSubmiting || activeStage === lead?.stageId) return;

    const newStage = leadStages.find((stage) => stage.id === activeStage);

    if (!newStage) return;

    const data = { stageId: activeStage };

    if (newStage.isConversion) {
      await convertLead(data);
    } else if (
      newStage.isLost === true &&
      listLostReason.length > 0 &&
      !lead?.lostReason &&
      lead?.lostReason === ''
    ) {
      setOpenModalReason(true);
      setUpdateLostReason(data);
    } else {
      await changeLeadStage(data);
    }
  };

  function handleWhatsAppMessage(phone) {
    let ddi = '';
    let number = '';

    if (typeof phone === 'object' && phone !== null) {
      ddi = phone.ddi || '';
      number = phone.number || '';
    } else if (typeof phone === 'string') {
      number = phone;
    }

    const phoneNumberWithoutMask = removeMaskSpecialCharacters(number);
    let data = {
      nome: lead?.name,
      telefone: phoneNumberWithoutMask !== '' ? phoneNumberWithoutMask : '',
      ddi: ddi
    };

    setWhatsAppMessageContactInfoLead(data);
    setIsisModalTemplateMessageLeadOpen(!isModalTemplateMessageLeadOpen);
    return whatsAppMessageContactInfoLead;
  }

  useEffect(() => {
    LeadStageService.listOrdenade(recordTypeId)
      .then((res) => {
        setLeadStages(res.data.data);
      })
      .catch(() => {
        toast.error('Erro ao carregar as fases.', {
          closeOnClick: true,
          autoClose: 3000
        });
      });
  }, [recordTypeId]);

  if (isLoadingCustomFields) {
    return (
      <Row className="justify-content-md-center">
        <Loader />
      </Row>
    );
  }

  const onSubmit = async (data) => {
    if (isEditLostReason === true) return [];

    data.phone = normalizePhoneNumber(
      data?.__number__ || data?.phone?.number || data?.phone_number
    );
    data.ddi = normalizeDDI(
      data?.__ddi__ ||
        data?.phone?.ddi ||
        data?.phone_ddi ||
        getDefaultCountry(dataDTO?.phone)?.dialCode
    );

    let dataToSubmit = data;
    if (!recordType && data.catalogId && catalogFormRef.current) {
      dataToSubmit = catalogFormRef.current.formatProductsAndCatalogsToShow({
        ...data
      });
    }

    const dataDTO = formatCustomFieldsToSubmit(dataToSubmit, customFields);

    LeadService.updateLead(recordTypeId, id, dataDTO)
      .then(() => {
        toast.success('Lead atualizado com sucesso.', {
          autoClose: 3000,
          closeOnClick: true
        });
        getLeadById();
      })
      .catch((error) => {
        const errMsg = error?.response?.data?.message;
        toast.error(errMsg || 'Não foi possível atualizar o Lead.', {
          autoClose: 3000,
          closeOnClick: true
        });
      });
  };

  const cancelAction = () => {
    history.push('/admin/crm/lead', { recordTypeId });
  };

  const cancelSchedule = (scheduleId) => {
    if (!window.confirm('Cancelar agendamento?')) {
      return;
    } else {
      SchedulingCrmService.cancelScheduleCrm(scheduleId)
        .then(() => {
          toast.success('Agendamento cancelado com sucesso', {
            autoClose: 3000,
            closeOnClick: true
          });
          getLeadById();
        })
        .catch((error) => {
          toast.error(
            error || 'Houve um erro ao tentar cancelar o agendamento.',
            {
              autoClose: 3000,
              closeOnClick: true
            }
          );
        });
    }
  };

  const handleUpdateComment = (dataComment) => {
    setOpenModalUpdateComment(true);
    setDataCommentUpdate(dataComment);
  };

  const handleCreateComment = () => {
    setOpenModalCreateComment(true);
  };

  const handleOpenLeadTime = () => {
    setOpenModalLeadTime(true);
  };

  const handleUpdateSchedule = (dataSchedule) => {
    setIsSchedulingModalOpen(true);
    setIsToUpdateScheduling(true);
    setschedulingId(dataSchedule.id);
    setIsToCreateScheduling(false);
  };

  const reloadComments = () => {
    LeadService.getLeadComments(id).then((res) => {
      setListComments(res.data.data);
    });
  };

  const handleUpdateLostReason = async (data) => {
    if (data.isDeleted === true) {
      await LeadService.updateLeadLostReason(lead.id, data)
        .then(() => {
          toast.success('Motivo da Perda  deletado com sucesso.', {
            autoClose: 3000,
            closeOnClick: true
          });
          getLeadById();
          setIsEditLostReason(false);
        })
        .catch((error) => {
          const errMsg = error?.response?.data?.message;
          toast.error(errMsg || 'Não foi possível atualizar o Lead.', {
            autoClose: 3000,
            closeOnClick: true
          });
        });
    } else {
      await LeadService.updateLeadLostReason(lead.id, data)
        .then(() => {
          toast.success('Motivo da Perda  atualizado com sucesso.', {
            autoClose: 3000,
            closeOnClick: true
          });
          getLeadById();
          setIsEditLostReason(false);
        })
        .catch((error) => {
          const errMsg = error?.response?.data?.message;
          toast.error(errMsg || 'Não foi possível atualizar o Lead.', {
            autoClose: 3000,
            closeOnClick: true
          });
        });
    }
  };

  function handleEmailMessage(email) {
    if (!email) return;

    setLeadEmail(email);
    setIsModalEmailLeadOpen(!isModalEmailLeadOpen);
  }

  const handleEdit = async () => {
    setIsEditLostReason(true);
    setOpenModalReason(true);
  };

  return (
    <>
      <SimpleHeader
        name="Lead edition"
        parentName="Lead"
        returnPath="/admin/crm/lead"
        navigatorState={{ recordTypeId }}
      />
      <ModalLostReason
        isModalOpen={openModalReason}
        onModalToggle={setOpenModalReason}
        recordTypeId={recordTypeId}
        listLostReason={listLostReason}
        changeLeadStage={changeLeadStage}
        updateLostReason={updateLostReason}
        getLeadById={getLeadById}
        handleUpdateLostReason={handleUpdateLostReason}
        isEdit={isEditLostReason}
        leads={lead}
      />
      <Container className="configuration-container mt--6" fluid>
        <Card>
          <CardHeader
            style={{
              display: 'flex',
              flexDirection: 'column',
              padding: '1rem'
            }}
          >
            <div
              style={{
                display: 'flex',
                overflowX: 'auto',
                overflowY: 'hidden',
                paddingBottom: '0.5rem',
                width: '100%',
                scrollbarWidth: 'thin',
                scrollbarColor: '#888 #f1f1f1'
              }}
              className="stages-container"
            >
              {leadStages &&
                leadStages.map((stage) => (
                  <ButtonGroup
                    key={stage.id}
                    style={{ flex: 1, minWidth: 'max-content' }}
                  >
                    <Button
                      color={
                        activeStage === stage.id
                          ? 'primary'
                          : activeStage > stage.id
                          ? 'success'
                          : 'dark'
                      }
                      outline
                      disabled={!availableStages?.includes(stage.id)}
                      active={activeStage >= stage.id}
                      size="md"
                      type="button"
                      title="Fases do Lead"
                      onClick={() => {
                        changeStage(stage.id);
                      }}
                      style={{
                        width: '100%',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      {stage.name}
                      <li
                        className="fas fa-arrow-right ml-2"
                        style={{ float: 'right', marginTop: '3px' }}
                      />
                    </Button>
                  </ButtonGroup>
                ))}

              <Button
                style={{
                  marginLeft: '0.5rem',
                  flexShrink: 0,
                  minWidth: '150px'
                }}
                color="primary"
                size="sm"
                disabled={isSubmiting || activeStage === lead?.stageId}
                onClick={updateStage}
              >
                <li className="fas fa-check" /> Atualizar fase
              </Button>
            </div>
          </CardHeader>
          <CardBody>
            <Row className="mb-3">
              <Col sm="2">
                <h3 className="font-weight-bold small mb-0">Responsável:</h3>
                <span className="d-flex align-items-center">
                  <span id="responsible-edit-label" onClick={changeResponsible}>
                    {lead?.responsibleName}{' '}
                  </span>
                  <FiEdit
                    onClick={changeResponsible}
                    className="ml-2"
                    cursor="pointer"
                    textDecoration="underline"
                  />
                </span>
              </Col>
              <Col sm="3">
                <h3 className="font-weight-bold small mb-0">Criado em:</h3>
                <span>{toBrazilianFullDate(lead?.createdAt)}</span>
              </Col>
              <Col sm="3">
                <h3 className="font-weight-bold small mb-0">
                  Última modificação por:
                </h3>
                <span>{lead?.lastUpdatedByName}</span>
              </Col>
              <Col sm="3">
                <h3 className="font-weight-bold small mb-0">
                  Última modificação em:
                </h3>
                <span>{toBrazilianFullDate(lead?.lastUpdatedAt)}</span>
              </Col>
              <Col
                sm="1"
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                <h3 className="font-weight-bold small mb-0">Prazos do Lead:</h3>
                <Button
                  color="info"
                  size="sm"
                  onClick={() => handleOpenLeadTime()}
                >
                  <li className="fas fa-clock"></li>
                </Button>
              </Col>
            </Row>

            <hr
              style={{ margin: '0', paddingTop: '0', marginBottom: '2rem' }}
            />

            {lead?.lostReason && lead?.lostReason !== '' && (
              <>
                <CustomFieldsFilterToggle
                  className="small"
                  onClick={() => setOpenModalLostReason(!openModalLostReason)}
                >
                  <strong>Motivo da Perda </strong>
                  {openModalLostReason ? (
                    <FiChevronDown size={18} />
                  ) : (
                    <FiChevronRight size={18} />
                  )}
                </CustomFieldsFilterToggle>

                {openModalLostReason && (
                  <div style={{ marginBottom: '10px' }}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        backgroundColor: '#E0F7FA',
                        borderRadius: '16px',
                        padding: '0.5rem 0.5rem',
                        fontSize: '14px'
                      }}
                    >
                      <span
                        style={{
                          flex: 1,
                          textAlign: 'left'
                        }}
                      >
                        <strong>{lead?.lostReason}</strong> -{' '}
                        {lead?.commentLostReason}
                      </span>
                      <FiEdit
                        onClick={handleEdit}
                        cursor="pointer"
                        style={{
                          color: '#00695C',
                          marginLeft: '0.5rem'
                        }}
                      />
                    </div>
                  </div>
                )}
                <hr
                  style={{ margin: '0', paddingTop: '0', marginBottom: '2rem' }}
                />
              </>
            )}

            <Form
              className="needs-validation"
              onSubmit={handleSubmit(onSubmit)}
            >
              <Row className="mb-3">
                <Col sm="6">
                  <label className="form-control-label text-capitalize">
                    Nome
                  </label>
                  <Controller
                    render={(props) => (
                      <Input
                        value={props.value}
                        onChange={props.onChange}
                        type="text"
                        placeholder="Nome"
                      />
                    )}
                    control={control}
                    defaultValue=""
                    name="name"
                  />
                </Col>
                <Col sm="6">
                  <label className="form-control-label text-capitalize">
                    Email
                  </label>

                  <div style={{ display: 'flex', gap: '8px' }}>
                    <Controller
                      render={(props) => (
                        <Input
                          value={props.value}
                          onChange={props.onChange}
                          type="email"
                          placeholder="Email"
                        />
                      )}
                      control={control}
                      defaultValue=""
                      name="email"
                    />

                    <Button
                      color="primary"
                      type="button"
                      onClick={() => handleEmailMessage(watch('email'))}
                      title="Enviar email"
                    >
                      <i className="fas fa-envelope" />
                    </Button>
                  </div>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col sm="6">
                  <FlexController
                    type="phone"
                    label="Telefone"
                    name="phone"
                    disabled={false}
                    showMessageButton={showMessageIconOnPhoneField}
                    showCallButton={showCallIconOnPhoneField}
                    handleSendTemplate={handleWhatsAppMessage}
                    watch={watch}
                    value={watch('phone')}
                    control={control}
                    errors={errors}
                    valueController={(fieldName, value) => {
                      setValue(fieldName, value);
                    }}
                  />

                  {/* <FlexController
                    type="phone"
                    label="Telefone"
                    name="phone"
                    disabled={false}
                    showMessageButton={showMessageIconOnPhoneField}
                    showCallButton={showCallIconOnPhoneField}
                    handleSendTemplate={handleWhatsAppMessage}
                    watch={watch}
                    value={watch('phone')}
                    control={control}
                    errors={errors}
                    rules={{ required: 'Campo obrigatório' }}
                    valueController={(fieldName, value) => {
                      setValue(fieldName, value);
                    }}
                  /> */}
                </Col>

                <CustomFieldsInputsForm
                  fields={filteredCustomFields}
                  control={control}
                  watch={watch}
                  errors={errors}
                  isOnEditPage={true}
                  setValue={setValue}
                  setChatCreatedOnIsolatedMessageId={
                    setChatCreatedOnIsolatedMessageId
                  }
                  setCallUniqueId={setCallUniqueId}
                  isTryingToCreateAContactAttempt={true}
                  Controller={Controller}
                  isUpdate={true}
                  options={{
                    showCallIconOnPhoneField: true,
                    showMessageIconOnPhoneField: true
                  }}
                  contactMessageClientName={lead?.name}
                />
              </Row>

              {(!recordType || lead?.wasCreatedWithProduct) && (
                <>
                  <CatalogProductsForm
                    ref={catalogFormRef}
                    watch={watch}
                    getValues={getValues}
                    control={control}
                    setValue={setValue}
                    isEditing={true}
                    catalogData={leadCatalog}
                    setCatalogData={setLeadCatalog}
                  />

                  <Row className="mt-3">
                    <Col>
                      <ShowHistoryChanges data={leadCatalogChangeHistory} />
                    </Col>
                  </Row>
                </>
              )}

              {listSchedules ? (
                <ListSchedules
                  listSchedules={listSchedules}
                  handleUpdateSchedule={handleUpdateSchedule}
                  cancelSchedule={cancelSchedule}
                />
              ) : (
                <Row className="justify-content-md-center">
                  <Loader
                    type="TailSpin"
                    color="#35ac50"
                    height={100}
                    width={100}
                  />
                </Row>
              )}
              <ModalSchedulingProtocol
                className="modal-lg"
                show={isSchedulingModalOpen}
                onModalToggle={setIsSchedulingModalOpen}
                schedulingId={schedulingId}
                setschedulingId={setschedulingId}
                isToCreateScheduling={isToCreateScheduling}
                isToUpdateScheduling={isToUpdateScheduling}
                entity={'LEAD'}
                entityId={id}
                recordTypeId={recordTypeId}
                getEntityById={getLeadById}
                isFromNotification={false}
                isCurrentResponsible={isCurrentResponsible}
              />
              <Col className="text-right">
                <Button
                  title="Adicionar novo agendamento"
                  color="success"
                  type="button"
                  onClick={() => {
                    setIsSchedulingModalOpen(true);
                    setIsToCreateScheduling(true);
                  }}
                >
                  <FiPlus size={16} /> Adicionar agendamento
                </Button>
              </Col>
              {listComments && (
                <ListComments
                  listComments={listComments}
                  reloadComments={reloadComments}
                  handleUpdateComment={handleUpdateComment}
                />
              )}

              <Row style={{ paddingTop: '20px' }}>
                <Col className="text-right">
                  <Button
                    title="Adicionar novo comentário"
                    color="success"
                    type="button"
                    onClick={() => handleCreateComment()}
                  >
                    <FiPlus size={16} /> Adicionar Comentário
                  </Button>
                </Col>
              </Row>

              {leadConversations.length > 0 && (
                <>
                  <Row className="mt-4">
                    <Col>
                      <h3 className="form-control-label">
                        Conversas Associadas
                      </h3>
                    </Col>
                  </Row>
                  {leadConversations.map((conversation) => (
                    <Card
                      key={conversation._id || conversation.id}
                      className="mb-3"
                    >
                      <CardBody>
                        <Row className="align-items-center">
                          <Col md="10">
                            <div>
                              <strong>Cliente:</strong>{' '}
                              {conversation.cliente?.nome || '-'}
                            </div>
                          </Col>
                          <Col md="2" className="text-right">
                            <ConversationDetails
                              conversationData={conversation}
                              buttonText="Exibir conversa"
                              buttonSize="md"
                              buttonColor="success"
                            />
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  ))}
                </>
              )}

              <Row style={{ paddingTop: '20px', paddingBottom: '40px' }}>
                <Col>
                  <h3 className="form-control-label mt-2">Anexo(s)</h3>
                  <Attachments
                    entityId={lead?.id}
                    attachments={lead?.attachments}
                    onAdded={(addedAttachments) => {
                      setLead((prev) => ({
                        ...prev,
                        attachments: [...prev.attachments, ...addedAttachments]
                      }));
                    }}
                    onDeleted={(attachmentId) => {
                      const remainAttachments = lead.attachments.filter(
                        (att) => att.id !== attachmentId
                      );
                      setLead((prev) => ({
                        ...prev,
                        attachments: remainAttachments
                      }));
                    }}
                    entityService={LeadService}
                    isButtonDisabled={lead?.isConverted}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="text-left">
                  <ReactButton
                    btnColor="confirmation"
                    type="submit"
                    disabled={lead?.isConverted}
                  >
                    Salvar
                  </ReactButton>

                  <ReactButton
                    btnColor="cancelation"
                    onClick={() => {
                      return cancelAction();
                    }}
                  >
                    Cancelar
                  </ReactButton>
                </Col>
                <Col className="text-right">
                  <Button
                    color="primary"
                    type="button"
                    onClick={() => openContactAttemptTimeline()}
                  >
                    <i className="fas fa-history" /> Histórico de Tentativas de
                    Contato
                  </Button>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
      </Container>

      <SendEmailModal
        leadEmail={leadEmail}
        leadId={id}
        isModalOpen={isModalEmailLeadOpen}
        onModalToggle={setIsModalEmailLeadOpen}
        setIsModalOpen={setIsModalEmailLeadOpen}
      />

      <ConvertLeadModal
        isModalOpen={isConvertLeadModalOpen}
        onModalToggle={setIsConvertLeadModalOpen}
        lead={lead}
      />
      <ChangeResponsibleModal
        isModalOpen={isChangeReponsibleModalOpen}
        onModalToggle={setIsChangeReponsibleModalOpen}
        leadId={lead?.id}
        callback={getLeadById}
      />
      <CommentModal
        render={getCommnents}
        leadId={id}
        isModalOpen={openModalCreateComment}
        onModalToggle={setOpenModalCreateComment}
        unmountOnClose={true}
      />
      <ModalComment
        render={getCommnents}
        dataComment={dataCommentUpdate}
        isModalOpen={openModalUpdateComment}
        onModalToggle={setOpenModalUpdateComment}
        unmountOnClose={true}
      />
      <TemplatesModal
        isModalOpen={isModalTemplateMessageLeadOpen}
        onModalToggle={setIsisModalTemplateMessageLeadOpen}
        clientNumber={whatsAppMessageContactInfoLead.telefone}
        clientDDI={whatsAppMessageContactInfoLead.ddi}
        clientName={whatsAppMessageContactInfoLead.nome}
        clientId={whatsAppMessageContactInfoLead.clientId ?? ''}
        setChatCreatedOnIsolatedMessageId={setChatCreatedOnIsolatedMessageId}
        isTryingToCreateAContactAttempt={true}
        isIsolated={true}
      />
      {id && (
        <ContactAttemptTimelineModal
          entityId={id}
          entityType="LEAD"
          isModalOpen={isContactAttemptTimelineModalOpen}
          onModalToggle={setIsContactAttemptTimelineModalOpen}
        />
      )}
      <LeadTimeModal
        leadId={id}
        isModalOpen={openModalLeadTime}
        onModalToggle={setOpenModalLeadTime}
        unmountOnClose={true}
        changedStage={changedStage}
        setChangedStage={setChangedStage}
      />
    </>
  );
};

export default LeadEdit;
